// NPM Imports
import React, { useContext } from 'react'
// Quote Context
import { useQuoteContext } from '../../../hooks/useQuoteContext'
// Component Imports
// JS Imports
import { formatFloatAsCurrencySymbol } from '../../../common/helpers.mjs'
import { shouldDisableDiscount } from '../../../js/validate'
import DiscountDescriptionBox from '../../ui-helper-elements/DiscountDescriptionBox'
// Asset Imports

export default function GroupImpDiscountRow({ order = 1 }) {
   const state = useQuoteContext()
   const discountCode = 'groupChildDiscount'
   const { getString } = state

   if (state.user_view == 'Internal' || state.discountGroupImp)
      return (
         <div className='row' style={{ order: order }}>
            <div className='col-bhr1'>
               <DiscountDescriptionBox
                  discountDescription={
                     state.discount_list[discountCode]['DiscountDescription']
                  }
                  discountName={
                     state.discount_list[discountCode]['DiscountName']
                  }
                  hoverTitle={getString(
                     'product.GroupImpDiscountRow.DiscountDescriptionBox.HoverText',
                  )}
               />
            </div>
            <div className='col'>
               <input
                  className='input-field'
                  type='checkbox'
                  checked={state.discountGroupImp}
                  disabled={shouldDisableDiscount(state, discountCode)}
                  onChange={() => state.setDiscountGroupImp((prev) => !prev)}
               />
            </div>
            <div className='col'>
               {formatFloatAsCurrencySymbol(
                  state.discount_list[discountCode]['DiscountAmount'],
                  state.currencyObject,
               )}
            </div>
         </div>
      )
}
